import { Effect } from 'effect';
import { ApiClient } from '@listening/api-contract/api-client-tag';
import type {
  DocumentInsightsSelection,
  EnsureDocumentInsightsRequest,
} from '@listening/api-contract/document-insights';

export const savedDocumentInsightsKey = (
  userId: string,
  audioId: string,
  selection: typeof DocumentInsightsSelection.Type,
) =>
  [
    'document-insights',
    userId,
    audioId,
    selection.model,
    selection.context,
  ] as const;

export const ensureSavedDocumentInsights = (
  input: typeof EnsureDocumentInsightsRequest.Type & { audioId: string },
) =>
  Effect.gen(function* () {
    const api = yield* ApiClient;
    return yield* api.Audio.EnsureDocumentInsights({
      params: { audioId: input.audioId },
      payload: {
        requestId: input.requestId,
        model: input.model,
        context: input.context,
        ...(input.retryRequestId
          ? { retryRequestId: input.retryRequestId }
          : {}),
      },
    });
  });

export const loadSavedDocumentInsights = (
  audioId: string,
  selection: typeof DocumentInsightsSelection.Type,
) =>
  Effect.gen(function* () {
    const api = yield* ApiClient;
    const saved = yield* api.Audio.GetSavedDocumentInsights({
      params: { audioId },
      query: selection,
    });
    if (saved) return saved;
    return yield* ensureSavedDocumentInsights({
      audioId,
      ...selection,
      requestId: crypto.randomUUID(),
    });
  });
